import Main from "./Main";
import { useState } from "react";
import Aside from "./Aside";
import "./index.css";


const App = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailValue, setEmailValue] = useState('');

  
  const onFormSubmit = (email) => {
    setEmailValue(email)
    setFormSubmitted(true);
  }

  const handleClick = () => {
    setFormSubmitted(false);
  }
  
  return (
    <div>
        {!formSubmitted  && <Main onFormSubmit={onFormSubmit} />}
        {formSubmitted && <Aside handleClick={handleClick} emailValue={emailValue} />}


    </div>
  );
}

export default App;